import React, { FormEvent, Fragment } from 'react';
import { InputText, Button } from '@/components';
import { UseFormReturn } from 'src/hooks';
import RecoverAccount from '@/model/RecoverAccount';
import PasswordRecoveryStrategy from '@/model/PasswordRecoveryStrategy';
import { updateMask } from '@/helpers/masks/mobilePhone';
import { FormInputNameRegisterConfirm } from '../types';

interface RegisterConfirmContentProps extends Pick<
  UseFormReturn,
  'formData' | 'formErrors' | 'onChangeFormInput'
> {
  state: boolean;
  onSubmit: (e: FormEvent) => void;
  recoverAccount?: RecoverAccount;
  onSubmitResendCode: (e: FormEvent) => void;
  onChangePersonData: () => void;
}

export const RegisterConfirmContent: React.FC<RegisterConfirmContentProps> = ({
  state,
  formData,
  formErrors,
  recoverAccount,
  onChangeFormInput,
  onSubmit,
  onSubmitResendCode,
  onChangePersonData,
}) => (
  <Fragment>
    {recoverAccount && (
      <div className="mt-8 w-full mx-auto p-2 bg-white">
        <div className="text-center">
          <h1 className="text-3xl text-heading font-dmsans font-bold mb-4">
            Ativação por{' '}
            {recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL
              ? 'E-mail'
              : 'Whatsapp'}
          </h1>
          <p className="text-lg text-body font-dmsans mb-6">
            Verifique seu{' '}
            {recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL
              ? 'e-mail'
              : 'whatsapp'}{' '}
            <span className="font-semibold">
              {recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL
                ? recoverAccount.email
                : updateMask(recoverAccount.phone || '')}
            </span>{' '}
            e informe abaixo o código de ativação.
          </p>
          {recoverAccount.recoveryStrategy === PasswordRecoveryStrategy.EMAIL && (
            <p className="text-sm text-gray-500 mb-10">
              <strong className="text-red-600">Dica:</strong> Se não encontrar o e-mail, verifique
              também sua <span className="font-semibold text-red-600">caixa de spam</span> ou{' '}
              <span className="font-semibold text-red-600">lixeira</span>.
            </p>
          )}
        </div>

        <form onSubmit={onSubmit} className="space-y-6">
          <InputText
            name="code"
            label="Código de confirmação"
            placeholder="Ex: 123456"
            className="appearance-none w-full rounded-md text-heading leading-tight focus:outline-none focus:shadow-outline text-sm font-dmsans"
            value={formData[FormInputNameRegisterConfirm.code]}
            onChange={e => onChangeFormInput(FormInputNameRegisterConfirm.code)(e.target.value)}
            error={formErrors.code && formErrors.code[0]}
          />

          <div className="mt-2 space-y-4">
            <Button
              type="submit"
              title="Confirmar e acessar minha conta"
              buttonStyle="primary"
              size="xlg"
              className="w-full"
              disabled={formData[FormInputNameRegisterConfirm.code] === '' || state}
            />
            <div
              className={
                recoverAccount.recoveryStrategy !== PasswordRecoveryStrategy.EMAIL
                  ? 'grid grid-cols-1 gap-3 sm:grid-cols-2'
                  : ''
              }
            >
              {recoverAccount.recoveryStrategy !== PasswordRecoveryStrategy.EMAIL && (
                <Button
                  type="button"
                  title="O número está errado"
                  buttonStyle="outlined"
                  size="xlg"
                  className="w-full"
                  onClick={onChangePersonData}
                  disabled={state}
                />
              )}

              <Button
                type="button"
                title="Reenviar código"
                buttonStyle="outlined"
                size="xlg"
                className="w-full"
                onClick={onSubmitResendCode}
                disabled={state}
              />
            </div>
          </div>
        </form>
      </div>
    )}
  </Fragment>
);
